//- ==================================================
//- JavaScript: Widget
//- ==================================================

(function () {

  'use strict';

  var $btn = $('[data-register-explorer-overlay]');
  var target = $btn.attr('data-register-explorer-overlay');

  $(window).on('resize', function (event) {
    if (window.matchMedia('(min-width: 1200px)').matches) {
      $btn.addClass('in');
      $(target).addClass('in');
    } else {
      $btn.removeClass('in');
      $(target).removeClass('in');
    }
  }).resize();

  $(document).on('click', '[data-register-explorer-overlay]', function (ev) {
    ev.preventDefault();

    var $this = $(this);
    var $icon = $this.find('svg.icon use');
    var target = $this.attr('data-register-explorer-overlay');

    $this.toggleClass('in');
    $(target).toggleClass('in');

    if ($this.hasClass('in')) {
      $this.attr('title', 'Close');
      $icon.attr({
        'aria-label': 'Close',
        'xlink:href': '/svg/icons.svg#arrow_forward'
      });
    } else {
      $this.attr('title', 'Open');
      $icon.attr({
        'aria-label': 'Open',
        'xlink:href': '/svg/icons.svg#arrow_back'
      });
    }

  });
})();

function registerExplorerWidget(selector, link_id) {
  var $container = $(selector);
  var $widget = $container.parents('[data-form="widget"]').eq(0);
  var $tagContainers = $widget.find('[data-form="tags-container"]');
  var $tagItemTpl = $widget.find('#registerTplItems [data-tpl="tag-item"]').eq(0);
  var $nearMe = $widget.find('[data-form="near-me"]');
  var $overlayContainer = $widget.find('[data-form="overlay-items"]');
  var $tooltipsContainer = $widget.find('[data-form="tooltips"]');
  var $thumbnailsContainer = $widget.find('[data-form="thumbnails"]');
  var $map = $container.find('[data-form="explorer-map-obj"]');
  var $searchForm = $widget.find('[data-action="form-register-search"]');
  var latlng = { lat: 39.123462, lng: -94.744192 };

  var $filterTypes = $widget.find('[data-filter="types"]');
  var $filterConditions = $widget.find('[data-filter="conditions"]');
  var $filterStyles = $widget.find('[data-filter="styles"]');
  var $filterClassifications = $widget.find('[data-filter="classifications"]');
  var map;

  map = new google.maps.Map($map[0], {
    center: latlng,
    zoom: (mobilecheck() ? 2 : 5),
    streetViewControlOptions: {
      position: google.maps.ControlPosition.LEFT_TOP
    },
    zoomControlOptions: {
      position: google.maps.ControlPosition.LEFT_TOP
    },
    scrollwheel: false,
    styles: [{
      'featureType': 'administrative',
      'elementType': 'labels.text.fill',
      'stylers': [{
        'color': '#444444'
      }]
    }, {
      'featureType': 'landscape',
      'elementType': 'all',
      'stylers': [{
        'color': '#f2f2f2'
      }]
    }, {
      'featureType': 'poi',
      'elementType': 'all',
      'stylers': [{
        'visibility': 'off'
      }]
    }, {
      'featureType': 'road',
      'elementType': 'all',
      'stylers': [{
        'saturation': -100
      }, {
        'lightness': 45
      }]
    }, {
      'featureType': 'road.highway',
      'elementType': 'all',
      'stylers': [{
        'visibility': 'simplified'
      }]
    }, {
      'featureType': 'road.arterial',
      'elementType': 'labels.icon',
      'stylers': [{
        'visibility': 'off'
      }]
    }, {
      'featureType': 'transit',
      'elementType': 'all',
      'stylers': [{
        'visibility': 'off'
      }]
    }, {
      'featureType': 'water',
      'elementType': 'all',
      'stylers': [{
        'color': '#c8cacb'
      }, {
        'visibility': 'on'
      }]
    }]
  });

  map.addListener('center_changed', function () {
    $('[data-marker]').removeClass('in');
  });

  $overlayContainer.on('click', '[data-reference]', function (ev) {
    ev.preventDefault();
    ev.stopPropagation();
    var $this = $(this);

    if (mobilecheck()) {
      location.href = $this.attr('data-url');
    } else {
      var marker = $('[data-marker]').filter('[data-reference="' + $this.attr('data-reference') + '"]')
        .data('marker');

      map.setZoom(10);
      google.maps.event.trigger(marker, 'click');
    }
  });

  exec();

  function exec() {
    map.setOptions({
      minZoom: 3,
      maxZoom: 15
    });

    $nearMe.on('click', function (ev) {
      ev.preventDefault();
      ev.stopPropagation();

      $('[data-form="open-map-register"]').click();

      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(function (position) {
          map.panTo({ lat: position.coords.latitude, lng: position.coords.longitude });
          map.setZoom(10);

          panToClosestMarker(map, markers);
        });
      }

    });

    $searchForm.on('change', function (ev) {
      rebuildTags();
    });

    $searchForm.on('change', '[name="bstatus[]"]', function (ev) {
      $searchForm.eq(0).submit();
    });

    $searchForm.on('submit', function (ev) {
      ev.preventDefault();

      filterRegister();
    });

    $tagContainers.on('click', '[data-action="tag-remove"]', function (ev) {
      ev.preventDefault();

      var $this = $(this);
      var $tag = $this;
      var $field = $tag.data('tag-field');

      if ($field.is('select')) {
        $field
          .find('option[value="' + $tag.data('tag-value') + '"]')
          .prop('selected', false);

        $field.trigger('change.select2');
      } else if ($field.is(':checkbox')) {
        $field.prop('checked', false);
      } else {
        $field.val('');
      }

      $tag.remove();

      $searchForm.eq(0).submit();
    });

    $([])
      .add($filterConditions)
      .add($filterTypes)
      .add($filterClassifications)
      .add($filterStyles)
      .on('change', function (ev) {
        var $this = $(this);
        filterRegister($this);
      });

    filterRegister();
  }

  function mapHeight() {
    $(window).on('resize', function (ev) {
      ev.preventDefault();

      var headerHeight = $widget.find('.register-explorer__nav').height() + $widget.find('.register-explorer__filter').height();

      var mapHeight = $(window).height() - headerHeight - 60;

      $map.css('height', mapHeight);
    }).resize();
  }
  mapHeight();

  $widget.find('[select2]').select2();

  function filterRegister($filter) {
    $container.addClass('loading');
    var queryString = $searchForm.serialize();
    $('body').addClass('loading');

    $.post('/widget-api/' + link_id, queryString, function (r) {
      queryString = queryString.replace(/\??term\=$/, '');

      // history.pushState(null, {}, location.pathname + (queryString ? '?' + queryString : ''));

      if (r.status == true) {
        $container.addLoading();
        $overlayContainer.children().remove();
        $overlayContainer.append(r.data.renders.overlays);

        $tooltipsContainer.children().remove();
        $tooltipsContainer.append(r.data.renders.tooltips);

        $thumbnailsContainer.children().remove();
        $thumbnailsContainer.append(r.data.renders.thumbnails);

        rebuildFilters(r.data.filters, $filter);
        rebuildTags();
        rebuildMarkers(r.data.registers);

        $('body').removeClass('loading');
      }
    });
  }

  function rebuildFilters(filters, $filter) {
    if (!$filterConditions.is($filter)) {
      $filterConditions.children().not(':selected').remove();
      $filterConditions.append(filters.conditions.map(function (item) {
        if (item)
          return '<option value="' + item._id + '">' + item.title + '</option>';
        else return null;
      }));
    }

    if (!$filterClassifications.is($filter)) {
      $filterClassifications.children().not(':selected').remove();
      $filterClassifications.append(filters.classifications.map(function (item) {
        if (item)
          return '<option value="' + item._id + '">' + item.title + '</option>';
        else return null;
      }));
    }

    if (!$filterStyles.is($filter)) {
      $filterStyles.children().not(':selected').remove();
      $filterStyles.append(filters.styles.map(function (item) {
        if (item)
          return '<option value="' + item._id + '">' + item.name + '</option>';
        else return null;
      }));
    }

    if (!$filterTypes.is($filter)) {
      $filterTypes.children().not(':selected').remove();
      console.log(filters.types)
      $filterTypes.append(filters.types.map(function (item) {
        if (item)
          return '<option value="' + item._id + '">' + item.title + '</option>';
        else return null;
      }));
    }
  }

  var urlBase = '//' + location.hostname + (location.port ? ':' + location.port : '') + '/img/misc';
  var markers = [];
  var icons = {
    saved: {
      icon: urlBase + '/pin-green.png'
    },
    threat: {
      icon: urlBase + '/pin-yellow.png'
    },
    lost: {
      icon: urlBase + '/pin-red.png'
    },
    default: {
      icon: urlBase + '/pin-gray.png'
    }
  };


  function rebuildMarkers(registers) {
    var $tooltips = $('[data-marker]');

    if (markers.length > 0) {
      for (var i = 0; i < markers.length; i++) {
        markers[i].setMap(null);
      }

      markers = [];
    }

    $container.addLoading();

    var step = Math.floor(2000 / $tooltips.length);
    var last = 0;
    $tooltips.each(function (k, item) {
      var $item = $(item);
      var $svg = $item.find('svg');

      var latlng = {
        lat: parseFloat($item.attr('data-latitude')),
        lng: parseFloat($item.attr('data-longitude')),
      };

      var type = 'default';

      if ($svg.hasClass('icon--threatened'))
        type = 'threatened';

      if ($svg.hasClass('icon--lost'))
        type = 'lost';

      if ($svg.hasClass('icon--saved'))
        type = 'saved';

      var marker = new google.maps.Marker({
        position: latlng,
        map: map,
        icon: icons[type] ? icons[type].icon : icons['default'].icon,
        animation: google.maps.Animation.DROP,
        title: $item.attr('data-marker-title')
      });

      marker.tooltip = $item;

      marker.addListener('click', function () {
        var $tooltip = this.tooltip;
        var coords = {
          lat: marker.getPosition().lat(),
          lng: marker.getPosition().lng(),
        };

        if (map.getZoom() < 6) {
          map.setZoom(6);
        }
        map.panTo(coords);

        setTimeout(function () {
          var point = fromLatLngToPoint(marker.getPosition(), map);

          $tooltip.css({
            left: (point.x - 40),
            top: (point.y - $item.height()),
          }).addClass('in');
        }, 300);

      });

      $item.data('marker', marker);
      markers.push(marker);
    });

    panToClosestMarker(map, markers);
    setTimeout(function () {
      $container.removeLoading();
    }, 3000);
  }

  function rebuildTags() {
    clearTags();

    var fields = $searchForm.serializeObject();
    var tags = [];

    var item;
    for (var key in fields) {
      if (key == 'items') continue;
      item = fields[key];

      if (typeof item == 'object')
        addTags(key, item);
      else addTag(key, item);
    }
  }

  function clearTags() {
    $tagContainers.find('[data-form="tag-item"]:not([data-tag="fixed"])').remove();
  }

  function addTags(key, items) {
    for (var key2 in items) {
      addTag(key, items[key2]);
    }
  }

  function addTag(key, value) {
    if (!value) return;

    for (var i = 0, x = $tagContainers.length; i < x; i++) {
      var $field = $widget.find('[name="' + key + '"]');
      var tagTitle = value;

      if (key == 'bstatus') {
        $field = $widget.find('[name="' + key + '[]"][value="' + value + '"]');
        tagTitle = $field.attr('data-tag-title');
      } else if (key != 'term') {
        $field = $widget.find('[name="' + key + '[]"]');
        tagTitle = $widget.find('[name="' + key + '[]"] option[value="' + value + '"]').text();
      }

      var $clone = $tagItemTpl.clone();
      $clone.find('[item-title]').text(tagTitle);
      $clone.data('tag-field', $field);
      $clone.data('tag-value', value);

      if ($field.attr('data-tag') == 'fixed') {
        $clone.find('[data-form="tag-remove"]').remove();
      }

      $clone.appendTo($tagContainers.eq(i));
    }

  }
}

function fromLatLngToPoint(latLng, map) {
  var topRight = map.getProjection().fromLatLngToPoint(map.getBounds().getNorthEast());
  var bottomLeft = map.getProjection().fromLatLngToPoint(map.getBounds().getSouthWest());
  var scale = Math.pow(2, map.getZoom());
  var worldPoint = map.getProjection().fromLatLngToPoint(latLng);
  return new google.maps.Point((worldPoint.x - bottomLeft.x) * scale, (worldPoint.y - topRight.y) * scale);
}

function panToClosestMarker(map, markers) {
  var closest = {
    distance: 999999999999999999,
    item: null
  };

  for (var i = 0; i < markers.length; i++) {
    var center = map.getCenter();
    var markerPosition = markers[i].getPosition();

    var distance = getDistanceFromLatLonInKm(center.lat(), center.lng(), markerPosition.lat(), markerPosition.lng());

    if (distance < closest.distance) {
      closest.distance = distance;
      closest.item = markers[i];
    }
  }

  if (closest.item) {
    // map.setZoom(10);
    map.panTo(closest.item.getPosition());
  }
}

function getDistanceFromLatLonInKm(lat1, lon1, lat2, lon2) {
  var R = 6371; // Radius of the earth in km
  var dLat = deg2rad(lat2 - lat1); // deg2rad below
  var dLon = deg2rad(lon2 - lon1);
  var a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) *
    Math.sin(dLon / 2) * Math.sin(dLon / 2);
  var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  var d = R * c; // Distance in km
  return d;
}

function deg2rad(deg) {
  return deg * (Math.PI / 180);
}
